import React from "react";
import Activities from "./Activities";
import Banner from "./Banner";
import Footer from "./Footer";
import MobileProjects from "./MobileProjects";
import Techstack from "./Techstack";
import WebProjects from "./WebProjects";

function Home() {
  return (
    <>
      <Banner />

      <Techstack />

      <WebProjects />

      <MobileProjects />

      <Activities />

      <Footer />
    </>
  );
}

export default Home;
